module.exports = __webpack_public_path__ + "img/l-circle.f122f48c.svg";